/**
 * Transit-mixer (RMC truck) travel-time estimates for Chennai / city traffic.
 * OSRM "driving" duration is for cars and is too optimistic for loaded TMs.
 *
 * ~18 km/h average matches typical plant→Camp Road (~9 km ≈ 30 min).
 */
export const TRANSIT_MIXER_AVG_KMPH = 18;

/** Extra minutes for plant exit / gate / weighbridge before road travel. */
export const TRANSIT_MIXER_GATE_BUFFER_MINS = 5;

/**
 * One-way ETA in minutes from road distance (km).
 * @param {number} oneWayKm
 * @param {{ includeGateBuffer?: boolean }} [options]
 * @returns {number|null}
 */
export function estimateTransitMixerMins(oneWayKm, options = {}) {
  const km = Number(oneWayKm);
  if (!Number.isFinite(km) || km <= 0) {
    return null;
  }
  const travel = Math.max(1, Math.round((km / TRANSIT_MIXER_AVG_KMPH) * 60));
  if (options.includeGateBuffer) {
    return travel + TRANSIT_MIXER_GATE_BUFFER_MINS;
  }
  return travel;
}

export function formatTravelTime(mins) {
  const total = Math.round(Number(mins) || 0);
  if (total <= 0) {
    return '';
  }
  const hours = Math.floor(total / 60);
  const rem = total % 60;
  if (hours <= 0) {
    return `${rem} min`;
  }
  if (rem === 0) {
    return `${hours} hr`;
  }
  return `${hours} hr ${rem} min`;
}
